import React, { memo } from 'react';
import { Sparkles, Crown, Zap } from 'lucide-react';

const Hero = memo(() => {
  return (
    <section className="relative bg-gradient-to-br from-book-brown via-book-brown-light to-book-sepia text-book-cream overflow-hidden above-fold fcp-optimized">
      {/* Background texture overlay */}
      <div className="absolute inset-0 opacity-10 bg-repeat" style={{
        backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '20px 20px'
      }}></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="text-center">
          <div className="flex justify-center items-center space-x-2 mb-6">
            <Sparkles className="h-8 w-8 text-book-gold" />
            <h1 className="text-book-cream text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight">
              Ignite Your Fortune
            </h1>
            <Crown className="h-8 w-8 text-book-gold" />
          </div>

          <p className="text-xl md:text-2xl lg:text-3xl mb-8 max-w-4xl mx-auto leading-relaxed">
            Welcome to <span className="text-book-gold font-semibold">Brit Ember</span> – where the finest UK casino experiences come alive.
            Discover premium gaming platforms, exclusive bonuses, and the thrill of victory awaits.
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 mb-12">
            <div className="flex items-center space-x-2 text-book-gold">
              <Zap className="h-5 w-5" />
              <span className="text-lg font-medium">Exclusive Bonuses</span>
            </div>
            <div className="flex items-center space-x-2 text-book-gold">
              <Crown className="h-5 w-5" />
              <span className="text-lg font-medium">Trusted Platforms</span>
            </div>
            <div className="flex items-center space-x-2 text-book-gold">
              <Sparkles className="h-5 w-5" />
              <span className="text-lg font-medium">VIP Treatment</span>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-4xl mx-auto">
            <a href="#offers" className="book-button text-center py-3 px-4 text-sm md:text-base">
              Premium Offers
            </a>
            <a href="#about" className="book-button text-center py-3 px-4 text-sm md:text-base">
              About Us
            </a>
            <a href="#guides" className="book-button text-center py-3 px-4 text-sm md:text-base">
              Gaming Guides
            </a>
            <a href="#faq" className="book-button text-center py-3 px-4 text-sm md:text-base">
              FAQ
            </a>
            <a href="#news" className="book-button text-center py-3 px-4 text-sm md:text-base">
              Latest News
            </a>
            <a href="#contact" className="book-button text-center py-3 px-4 text-sm md:text-base">
              Contact Us
            </a>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-10 left-10 opacity-20">
          <div className="w-20 h-20 border-2 border-book-gold rounded-full"></div>
        </div>
        <div className="absolute bottom-10 right-10 opacity-20">
          <div className="w-16 h-16 border-2 border-book-gold transform rotate-45"></div>
        </div>
      </div>
    </section>
  );
});

Hero.displayName = 'Hero';

export default Hero;
